import { UIComponentProps, UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler } from '../uicomponent';
import { ListViewModel } from '../horizontallist/listviewmodel';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../uicomponentview';
import { VerticalListViewImpl } from './verticallistview';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { VerticalListCSSStyleImpl } from './verticallistcss';

export interface VerticalListComponentProps<T> extends UIComponentProps
{
    listViewModel: ListViewModel<T>;
}

export class VerticalListComponent<T, S extends UIComponentState> extends UIComponentImpl<VerticalListComponentProps<T>,S, UIDataModel> 
{
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new VerticalListViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new VerticalListCSSStyleImpl(applicationContext);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/verticallist/verticallistcomponent.tsx